import { createFileRoute } from '@tanstack/react-router'
import { FleetSection } from '@spcc/domains/assets'

export const Route = createFileRoute('/fleet/resources')({
  component: FleetResourcesPage,
})

function FleetResourcesPage() {
  return <FleetSection activeTab="resources" />
}
